import type { CSS } from '@grupoboticario/flora-react'

export const gridCss: CSS = {
  marginBottom: '$4'
}

export const newTagCss: CSS = {
  position: 'absolute',
  right: '$4',
  top: '$4',
  textTransform: 'uppercase'
}

export const getCardFlexCss = (hasPermission: boolean): CSS => ({
  width: '100%',
  height: '250px',
  background: hasPermission ? '$backgroundPrimary' : '$backgroundTertiary',
  borderRadius: '$medium',
  cursor: 'pointer',
  padding: '$5',
  pointerEvents: hasPermission ? 'auto' : 'none',
  boxShadow: hasPermission ? '$downSoft' : undefined,
  position: 'relative'
})

export const getIconBoxCss = (hasPermission: boolean): CSS => ({
  width: '$23',
  height: '$23',
  color: hasPermission ? '$actionableDefault' : '$nonInteractiveAuxiliar'
})

export const getCardTextCss = (): CSS => ({
  color: '$nonInteractiveAuxiliar'
})
